module.exports = "<footer class=\"main-footer\">\r\n  <div class=\"pull-right hidden-xs\">\r\n    <b>  Last Build Version :  V3.0 / Last Build Date :  2018-07-31</b>\r\n  </div>\r\n  <strong>  Copyright @ 2018 - 2019 # Supervision  (Pvt.) Ltd. All Right Reserved</strong>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/common/footer/footer.component.html
// module id = ./src/app/view/common/footer/footer.component.html
// module chunks = main